import * as types from '../actions/types';

const initialState = {
  calendarData: null,
  loading: false,
};

export default function eventsCalendar(state = initialState, action) {
  switch (action.type) {
    case types.SET_EVENTS_CALENDAR:
      return { ...state, calendarData: action.payload };
    case types.SET_EVENTS_CALENDAR_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
